var map = {
	"./templates/cards/blog-card": 1117,
	"./templates/cards/blog-card.json": 1117,
	"./templates/cards/completion": 1118,
	"./templates/cards/completion.json": 1118,
	"./templates/cards/list-card": 1119,
	"./templates/cards/list-card.json": 1119,
	"./templates/cards/loss-information": 1120,
	"./templates/cards/loss-information.json": 1120,
	"./templates/cards/no-data": 1121,
	"./templates/cards/no-data.json": 1121,
	"./templates/cards/order-summary": 1122,
	"./templates/cards/order-summary.json": 1122,
	"./templates/cards/profit-information": 1123,
	"./templates/cards/profit-information.json": 1123,
	"./templates/cards/redirect": 1124,
	"./templates/cards/redirect.json": 1124,
	"./templates/cards/review-card": 1125,
	"./templates/cards/review-card.json": 1125,
	"./templates/cards/summary-card": 1126,
	"./templates/cards/summary-card.json": 1126,
	"./templates/cards/technical-issue": 1127,
	"./templates/cards/technical-issue.json": 1127,
	"./templates/footer/footer-basic": 1128,
	"./templates/footer/footer-basic.json": 1128,
	"./templates/footer/footer-with-blog-title": 1129,
	"./templates/footer/footer-with-blog-title.json": 1129,
	"./templates/footer/footer-with-get-app-button": 1130,
	"./templates/footer/footer-with-get-app-button.json": 1130,
	"./templates/footer/footer-with-links": 1131,
	"./templates/footer/footer-with-links.json": 1131,
	"./templates/forms/address-form": 1132,
	"./templates/forms/address-form.json": 1132,
	"./templates/forms/contact-form": 1133,
	"./templates/forms/contact-form.json": 1133,
	"./templates/forms/login-form": 1134,
	"./templates/forms/login-form.json": 1134,
	"./templates/forms/otp-form": 1135,
	"./templates/forms/otp-form.json": 1135,
	"./templates/header/banner": 1136,
	"./templates/header/banner.json": 1136,
	"./templates/header/header-before-login": 1137,
	"./templates/header/header-before-login.json": 1137,
	"./templates/header/header-with-tab": 1138,
	"./templates/header/header-with-tab.json": 1138,
	"./templates/header/section-header-basic": 1139,
	"./templates/header/section-header-basic.json": 1139,
	"./templates/header/section-header-with-action": 1140,
	"./templates/header/section-header-with-action.json": 1140,
	"./templates/header/section-header-with-tags": 1141,
	"./templates/header/section-header-with-tags.json": 1141,
	"./templates/layouts/dashboard-layout": 1142,
	"./templates/layouts/dashboard-layout.json": 1142,
	"./templates/layouts/grid-layout": 1143,
	"./templates/layouts/grid-layout.json": 1143,
	"./templates/layouts/parallel-two-column": 1144,
	"./templates/layouts/parallel-two-column.json": 1144,
	"./templates/layouts/seventy-thirty-split-layout": 1145,
	"./templates/layouts/seventy-thirty-split-layout.json": 1145,
	"./templates/layouts/single-column-layout": 1146,
	"./templates/layouts/single-column-layout.json": 1146,
	"./templates/layouts/thirty-seventy-split-layout": 1147,
	"./templates/layouts/thirty-seventy-split-layout.json": 1147,
	"./templates/layouts/two-column-with-search": 1148,
	"./templates/layouts/two-column-with-search.json": 1148,
	"./templates/modal/delete-confirmation-modal": 1149,
	"./templates/modal/delete-confirmation-modal.json": 1149,
	"./templates/modal/simple-confirmation-modal": 1150,
	"./templates/modal/simple-confirmation-modal.json": 1150,
	"./templates/modal/success-modal": 1151,
	"./templates/modal/success-modal.json": 1151,
	"./templates/modal/terms-and-condition": 1152,
	"./templates/modal/terms-and-condition.json": 1152,
	"./templates/modal/unsuccessful-modal": 1153,
	"./templates/modal/unsuccessful-modal.json": 1153,
	"./templates/table/comparison-table": 1154,
	"./templates/table/comparison-table.json": 1154,
	"./templates/table/faq-list": 1155,
	"./templates/table/faq-list.json": 1155,
	"./templates/table/pricing-table": 1156,
	"./templates/table/pricing-table.json": 1156,
	"./templates/table/table-list": 1157,
	"./templates/table/table-list.json": 1157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1838;